<script>
  import acessosServico from '../servico';
  import Paginacao from '~componentes/Paginacao.vue';
  import DatePicker from 'vue2-datepicker';
  import $ from 'jquery';

  import "~componentes/../js/inspinia";

  export default {
    components: { Paginacao, DatePicker },
    data() {
      return {
        importacoes: [],
        rotulos: [],
        linhaSelecionada: null,
        filtrosAplicados: {},
        carregando: false,
        exportando: false,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        configuracao: this.$storage.configuracao(),
        filtros: this.camposFiltros(),
      }
    },
    methods: {
      camposFiltros() {
        return {
          periodo: '',
          numeroProcesso: '',
          exportador: '',
          status: 0,
        };
      },
      filtrosRequisicao() {
        const filtros = {
          usarPeriodo: false,
          dataDe: '',
          dataAte: '',
          numeroProcesso: this.filtros.numeroProcesso,
          exportador: this.filtros.exportador,
          status: this.filtros.status,
        };

        if (this.filtros.periodo && this.filtros.periodo[0] && this.filtros.periodo[1]) {
          filtros.usarPeriodo = true;
          filtros.dataDe = moment(this.filtros.periodo[0]).format('YYYY-MM-DD');
          filtros.dataAte = moment(this.filtros.periodo[1]).format('YYYY-MM-DD');
        }

        return filtros;
      },
      lista(pagina = 1) {
        this.carregando = true;
        this.filtrosAplicados = Object.assign({}, this.filtros);

        return acessosServico
          .listaImportacao(pagina, this.filtrosRequisicao())
          .then(dados => {
            this.carregando = false;

            this.importacoes = dados.registros;
            this.rotulos = dados.rotulos || [];
            this.totalRegistros = dados.totalRegistros;
            this.totalPaginas = dados.totalPaginas;
            this.registrosPorPagina = dados.registrosPorPagina;
          })
          .catch(() => {
            this.carregando = false;
          });
      },
      exportarExcel() {
        if (this.exportando) return;

        this.exportando = true;

        return acessosServico
          .listaImportacaoExcel(this.filtrosRequisicao())
          .then(arquivo => {
            this.exportando = false;

            if (arquivo === '') {
              this.$swal('', 'Nenhuma importação encontrada para exportar.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(() => {
            this.exportando = false;
            this.$swal('', 'Não foi possível gerar o Excel.', 'error');
          });
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();

        this.lista();
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      classeStatus(statusInteiro) {
        switch (statusInteiro) {
          case 0: return 'status-andamento';
          case 1: return 'status-concluida';
          case 2: return 'status-cancelada';
          case 3: return 'status-faturamento';
          default: return 'status-andamento';
        }
      },
      rotuloStatus(status) {
        return { 1: 'Em andamento', 2: 'Concluída', 3: 'Cancelada', 4: 'Em faturamento', 5: 'Em andamento + Em faturamento' }[status] || '';
      },
      monitorData(importacao, rotulo) {
        return (importacao.monitor && importacao.monitor[rotulo.posicao]) || '';
      },
      monitorTick(rotulo) {
        return rotulo.conclusao > 0 || rotulo.solicitacao > 0;
      },
      monitorPendente(valor) {
        return valor === 'Solicitado' || valor.indexOf('Previsto') === 0;
      },
      monitorVencido(importacao, valor) {
        if (!valor) return false;
        if (importacao.statusInteiro !== 0 && importacao.statusInteiro !== 3) return false;
        const data = moment(valor, 'DD/MM/YYYY', true);
        return data.isValid() && data.isBefore(moment().startOf('day'));
      },
      removerFiltro(chave) {
        if (chave === 'periodo') this.filtros.periodo = '';
        else if (chave === 'status') this.filtros[chave] = 0;
        else this.filtros[chave] = '';

        this.lista();
      },
    },
    computed: {
      chipsFiltros() {
        const f = this.filtrosAplicados;
        const chips = [];

        if (f.periodo && f.periodo[0] && f.periodo[1])
          chips.push({ chave: 'periodo', texto: 'Período: ' + moment(f.periodo[0]).format('DD/MM/YYYY') + ' a ' + moment(f.periodo[1]).format('DD/MM/YYYY') });
        if (f.numeroProcesso) chips.push({ chave: 'numeroProcesso', texto: 'Processo: ' + f.numeroProcesso });
        if (f.exportador) chips.push({ chave: 'exportador', texto: 'Exportador: ' + f.exportador });
        if (f.status) chips.push({ chave: 'status', texto: 'Status: ' + this.rotuloStatus(f.status) });

        return chips;
      },
      totalColunas() {
        return 6 + this.rotulos.length;
      },
    },
    created() {
      if (!this.configuracao.utilizarImportacao) {
        this.$router.push('/acessos');
      }
    },
    mounted() {
      if (!this.configuracao.utilizarImportacao) {
        return;
      }

      this.lista();
    }
  }
</script>

<style scoped>
  .bannerRosto_interno_importacao {
    background: url('/img/acesso/banners/importacao.png');
  }

  .bannerRosto_interno {
    background-repeat: no-repeat;
    background-position: right -80px;
    overflow: hidden;
    background-size: cover;
    animation-name: img-ani;
    animation-duration: 1s;
    animation-timing-function: ease-in;
    left: 0px;
    width: 100%;
    height: 300px;
    position: absolute;
  }

  #sectionBanner .text-center {
    color: white;
    justify-content: center;
    padding-top: 40px;
    font-size: 35px;
  }

  .col-numero {
    text-align: right;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum";
  }
  .ibox-title {
    background-color: #fafbfc;
  }
  .ibox-content .control-label {
    color: #545b62;
    font-weight: 600;
  }
  .ibox-footer {
    padding-top: 6px;
  }
  .ibox-footer >>> ul.pagination > li > a {
    font-size: 13px;
    padding: 6px 12px;
  }
  .ibox-footer >>> p.no-margins {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .table-responsive {
    max-height: 68vh;
    overflow: auto;
  }

  .col-monitor {
    white-space: nowrap;
    font-size: 0.85em;
  }
  .monitor-vencido {
    color: #ed5565;
    font-weight: bold;
  }
  .monitor-divisor {
    border-left: 2px solid #cfd4da;
  }
  .tabela-importacoes .grupo-inicio {
    border-left: 2px solid #e2e5e9;
  }
  .bool-badge {
    display: inline-block;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 3px;
    font-size: 0.8em;
  }
  .bool-on { background-color: #1ab394; color: #ffffff; }
  .bool-alerta { background-color: #f8ac59; color: #ffffff; }
  .bool-off { background-color: #f2f3f4; color: #c4c8cc; }

  .tabela-importacoes > thead > tr > th {
    background-color: #e4e7ec;
    font-weight: 600;
    color: #23282e;
    border-bottom: 2px solid #c1c6cc;
    padding-top: 14px;
    padding-bottom: 14px;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .tabela-importacoes > thead > tr > th.col-monitor {
    background-color: #dbe0e6;
  }

  .tabela-importacoes > tbody > tr.linha-par > td {
    background-color: #f7f8fa;
  }

  .tabela-importacoes > tbody > tr > td.col-monitor {
    background-color: #fafbfc;
  }

  .tabela-importacoes > tbody > tr.linha-dados:hover > td {
    background-color: #dcebfb;
    cursor: pointer;
  }

  .tabela-importacoes > tbody > tr.linha-selecionada > td {
    background-color: #d3e5fb;
  }
  .tabela-importacoes > tbody > tr.linha-selecionada > td:first-child {
    box-shadow: inset 4px 0 0 #2f6fc4;
    font-weight: 600;
  }

  .importacoes-contexto {
    color: #8a9199;
    font-size: 13px;
    margin: 0 0 8px 2px;
  }
  .importacoes-contexto strong {
    color: #5a6570;
  }

  .dica-colunas {
    text-align: right;
    color: #8a9199;
    font-size: 12px;
    margin-bottom: 6px;
  }
  .filtros-ativos {
    margin-bottom: 8px;
  }
  .filtros-ativos-label {
    color: #8a9199;
    font-size: 12px;
    margin-right: 6px;
  }
  .chip-filtro {
    display: inline-block;
    background-color: #eef1f4;
    border: 1px solid #d5dae0;
    border-radius: 3px;
    padding: 2px 8px;
    margin: 0 4px 4px 0;
    font-size: 12px;
    color: #4a515a;
  }
  .chip-filtro .chip-remover {
    margin-left: 6px;
    color: #9aa1a8;
    cursor: pointer;
    font-weight: 600;
  }
  .chip-filtro .chip-remover:hover {
    color: #ed5565;
  }

  .col-forte {
    font-weight: 600;
  }

  .valor-negativo {
    color: #a94442;
    font-weight: 600;
  }

  .badge-status {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 3px;
    font-size: 0.9em;
    white-space: nowrap;
    border: 1px solid transparent;
  }
  .status-andamento { background-color: #eef1f4; color: #5a6570; border-color: #d5dae0; }
  .status-concluida { background-color: #e5f3ea; color: #1d7a4d; border-color: #bfe3cd; }
  .status-cancelada { background-color: #f6e7e7; color: #a94442; border-color: #e6c9c9; }
  .status-faturamento { background-color: #fbf1e0; color: #97711f; border-color: #ecdcb5; }

  .table-responsive::-webkit-scrollbar {
    height: 8px;
  }
  .table-responsive::-webkit-scrollbar-thumb {
    background-color: #c4c8cc;
    border-radius: 4px;
  }
  .table-responsive::-webkit-scrollbar-track {
    background-color: #f2f3f4;
  }
</style>

<template>
  <div>
    <section id="sectionBanner" class="bannerRosto_interno bannerRosto_interno_importacao">
      <div id="texto-img" class="text-center">
        <h1 class="text-center">
          <strong>
            <span id="lblTipo">IMPORTAÇÕES</span>
          </strong>
        </h1>
      </div>
    </section>

    <div class="container" style="padding-top:320px;">
      <div class="row">
        <div class="col-lg-12">
          <p class="importacoes-contexto">
            Acompanhe todas as importações realizadas · <strong>{{ totalRegistros }}</strong> registros
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
              <h5><i class="fa fa-search text-navy"></i> Filtros <small class="m-l-sm">Refine os registros da importação.</small></h5>

              <div class="ibox-tools">
                <span class="collapse-link">
                  <i class="fa fa-chevron-up"></i>
                </span>
              </div>
            </div>

            <div class="ibox-content">

              <div class="row">
                <div class="col-xs-12 col-sm-4">
                  <div class="form-group">
                    <label class="control-label">Período (data da importação)</label>

                    <date-picker v-model="filtros.periodo"
                                 input-class="form-control"
                                 range
                                 :editable="false"
                                 lang="pt-br"
                                 :confirm="true"
                                 range-separator="a"
                                 format="DD/MM/YYYY"
                                 :shortcuts="false">
                    </date-picker>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-3">
                  <div class="form-group">
                    <label class="control-label" for="status">Status</label>
                    <select id="status" class="form-control" v-model.number="filtros.status">
                      <option :value="0">(Todos)</option>
                      <option :value="1">Em andamento</option>
                      <option :value="2">Concluída</option>
                      <option :value="3">Cancelada</option>
                      <option :value="4">Em faturamento</option>
                      <option :value="5">Em andamento + Em faturamento</option>
                    </select>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-3">
                  <div class="form-group">
                    <label class="control-label" for="numeroProcesso">Número do processo</label>
                    <input type="text" class="form-control" id="numeroProcesso" v-model="filtros.numeroProcesso">
                  </div>
                </div>

                <div class="col-xs-12 col-sm-2">
                  <div class="form-group">
                    <label class="control-label" for="exportador">Exportador</label>
                    <input type="text" class="form-control" id="exportador" v-model="filtros.exportador">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group no-margins">
                    <button type="button" class="btn btn-success no-margins" @click="lista">
                      <i class="fa fa-search"></i>
                      Filtrar
                    </button>
                    <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                      <i class="fa fa-eraser"></i>
                      Limpar filtros
                    </button>
                    <button type="button" class="btn btn-primary no-margins" @click="exportarExcel" :disabled="exportando">
                      <i :class="exportando ? 'fa fa-spinner fa-pulse' : 'fa fa-table'"></i>
                      {{ exportando ? 'Gerando relatório...' : 'Gerar listagem em excel' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="ibox-footer">
              <div class="dica-colunas">
                <i class="fa fa-info-circle"></i>
                Passe o mouse sobre as colunas abreviadas para ver a descrição completa.
              </div>

              <div class="filtros-ativos" v-if="chipsFiltros.length > 0">
                <span class="filtros-ativos-label">Filtros ativos:</span>
                <span class="chip-filtro" v-for="chip in chipsFiltros" :key="chip.chave">
                  {{ chip.texto }}
                  <span class="chip-remover" @click="removerFiltro(chip.chave)" v-tooltip="'Remover filtro'">×</span>
                </span>
              </div>

              <div class="table-responsive">
                <table class="table table-bordered tabela-importacoes">
                  <thead>
                    <tr>
                      <th>Nº processo</th>
                      <th>Data importação</th>
                      <th>Exportador</th>
                      <th>Moeda</th>
                      <th class="text-right">Valor Importação</th>
                      <th>Status</th>
                      <th v-for="(rotulo, indexRotulo) in rotulos"
                          :key="rotulo.posicao"
                          class="text-center col-monitor"
                          :class="{ 'grupo-inicio': indexRotulo === 0, 'monitor-divisor': indexRotulo > 0 && indexRotulo % 4 === 0 }"
                          v-tooltip="rotulo.descricao">{{ rotulo.rotulo }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(importacao, index) in importacoes"
                        class="linha-dados"
                        :class="{ 'linha-par': index % 2 === 1, 'linha-selecionada': index === linhaSelecionada }"
                        @click="linhaSelecionada = index">
                      <td class="col-forte">{{ importacao.numeroProcesso || '---' }}</td>
                      <td>{{ importacao.dataImportacao | formatarData }} {{ importacao.dataImportacao | formatarHora }}</td>
                      <td class="col-forte">{{ importacao.nomeExportador || '---' }}</td>
                      <td>{{ importacao.nomeMoeda || '---' }}</td>
                      <td class="col-numero col-forte" :class="{ 'valor-negativo': importacao.valorTotalItens < 0 }">{{ importacao.valorTotalItens | formatarNumero }}</td>
                      <td>
                        <span v-if="importacao.statusImportacao" class="badge-status" :class="classeStatus(importacao.statusInteiro)">{{ importacao.statusImportacao }}</span>
                        <span v-else>---</span>
                      </td>
                      <td v-for="(rotulo, indexRotulo) in rotulos"
                          :key="rotulo.posicao"
                          class="text-center col-monitor"
                          :class="{ 'grupo-inicio': indexRotulo === 0, 'monitor-divisor': indexRotulo > 0 && indexRotulo % 4 === 0 }">
                        <template v-if="monitorTick(rotulo)">
                          <span v-if="monitorPendente(monitorData(importacao, rotulo))" class="bool-badge bool-alerta" v-tooltip="monitorData(importacao, rotulo)"><i class="fa fa-check"></i></span>
                          <span v-else-if="monitorData(importacao, rotulo)" class="bool-badge bool-on" v-tooltip="monitorData(importacao, rotulo)"><i class="fa fa-check"></i></span>
                          <span v-else class="bool-badge bool-off"><i class="fa fa-circle-o"></i></span>
                        </template>
                        <span v-else :class="{ 'monitor-vencido': monitorVencido(importacao, monitorData(importacao, rotulo)) }">{{ monitorData(importacao, rotulo) }}</span>
                      </td>
                    </tr>
                    <tr v-show="carregando">
                      <td :colspan="totalColunas" class="text-center">
                        <i class='fa fa-spinner fa-pulse'></i> Carregando...
                      </td>
                    </tr>
                    <tr v-show="!carregando && importacoes.length === 0">
                      <td :colspan="totalColunas" class="text-center">Nenhuma importação encontrada.</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <paginacao :page-count="totalPaginas"
                         :click-handler="lista"
                         :per-page="registrosPorPagina"
                         :register-count="totalRegistros"
                         :show-counter="true">
              </paginacao>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/AcessosImportacao.vue